import { render, staticRenderFns } from "./Editar-Lembrete-Medicacao.vue?vue&type=template&id=7333c356&scoped=true&"
import script from "./Editar-Lembrete-Medicacao.vue?vue&type=script&lang=js&"
export * from "./Editar-Lembrete-Medicacao.vue?vue&type=script&lang=js&"
import style0 from "./Editar-Lembrete-Medicacao.vue?vue&type=style&index=0&id=7333c356&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7333c356",
  null
  
)

component.options.__file = "Editar-Lembrete-Medicacao.vue"
export default component.exports